import React, { useState, useEffect, useRef } from "react";

import { isMobile } from "../../../utils";

import { StyledYoutubeIframe, VideoOverlay, Iframe } from "./style";

function YoutubeIframe({
  videoId,
  startTime,
  endTime,
  showControls,
  callBack,
  videoEndCallback,
}) {
  const tagId = "youtube-video-tag";

  const playerRef = useRef();

  const [playerState, setPlayerState] = useState(0);

  let url = `https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1&autoplay=1&modestbranding=1&rel=0&playsinline=${
    isMobile ? "1" : "0"
  }&`;

  if (startTime) {
    url = `${url}&start=${startTime}`;
  }
  if (endTime) {
    url = `${url}&end=${endTime}`;
  }
  if (!showControls) {
    url = `${url}&controls=0`;
  }

  const insertYoutubeIframeApiScriptToDOM = () => {
    const tag = document.createElement("script");
    tag.defer = true;
    tag.id = tagId;
    tag.src = "https://www.youtube.com/iframe_api";

    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  const onYouTubeIframeAPIReady = () => {
    const player = new window.YT.Player(videoId, {
      videoId: videoId,
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
    playerRef.current = player;
  };

  useEffect(() => {
    const element = document.getElementById(tagId);
    if (!element) {
      insertYoutubeIframeApiScriptToDOM(tagId);
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    } else {
      // onYouTubeIframeAPIReady();
    }
  }, []);

  useEffect(() => {
    const allPlayer = document.querySelectorAll(".youtube-ifrmae-video-player");
    allPlayer?.forEach((element) => {
      if (element.id !== videoId && playerState === 1) {
        element.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    });
  }, [playerState]);

  const onPlayerReady = () => {
    if (playerRef?.current?.playVideo) playerRef.current.playVideo();
  };

  const onPlayerStateChange = () => {
    if (playerRef?.current?.getPlayerState) {
      setPlayerState(playerRef.current.getPlayerState());
      if (playerRef.current.getPlayerState() === 0) {
        videoEndCallback();
      }
    }
  };

  const onOverlayClick = () => {
    if (
      playerRef?.current?.getPlayerState() != 1 &&
      playerRef?.current?.getPlayerState() != 0
    ) {
      if (playerRef?.current?.playVideo) playerRef.current.playVideo();
    } else {
      if (playerRef?.current?.pauseVideo) playerRef.current.pauseVideo();
    }
  };

  return (
    <StyledYoutubeIframe>
      {!showControls && <VideoOverlay onClick={onOverlayClick} />}
      <Iframe
        title={videoId}
        id={videoId}
        className="youtube-ifrmae-video-player"
        src={url}
        frameBorder="0"
        enablejsapi="true"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
        allowFullScreen={showControls ? "1" : "0"}
        crossorigin
        loading="lazy"
      />
    </StyledYoutubeIframe>
  );
}

export default YoutubeIframe;

// playerRef.current.cueVideoById({
//   videoId: String,
//   startSeconds: Number,
//   endSeconds: Number,
// });

// playerRef.current.loadVideoById({
//   videoId: String,
//   startSeconds: Number,
//   endSeconds: Number,
// });

// playerRef.current.cueVideoByUrl({
//   mediaContentUrl: String,
//   startSeconds: Number,
//   endSeconds: Number,
// });

// playerRef.current.loadVideoByUrl({
//   mediaContentUrl: String,
//   startSeconds: Number,
//   endSeconds: Number,
// });

// playerRef.current.cuePlaylist({
//   listType: String,
//   list: String,
//   index: Number,
//   startSeconds: Number,
// });

// playerRef.current.loadPlaylist({
//   list: String,
//   listType: String,
//   index: Number,
//   startSeconds: Number,
// });

// playerRef.current.playVideo()

// playerRef.current.pauseVideo()

// playerRef.current.stopVideo()

// playerRef.current.seekTo(seconds:Number, allowSeekAhead:Boolean)

// playerRef.current.nextVideo()

// playerRef.current.previousVideo()

// playerRef.current.playVideoAt(index:Number)

// playerRef.current.mute()

// playerRef.current.unMute()

// playerRef.current.isMuted()

// playerRef.current.setVolume(volume:Number)

// playerRef.current.getVolume()

// playerRef.current.setSize(width:Number, height:Number)

// playerRef.current.getPlaybackRate()

// playerRef.current.setPlaybackRate(suggestedRate:Number)

// playerRef.current.getAvailablePlaybackRates()

// playerRef.current.setLoop(loopPlaylists:Boolean)

// playerRef.current.setShuffle(shufflePlaylist:Boolean)

// playerRef.current.getVideoLoadedFraction()

// playerRef.current.getPlayerState()

// // -1 – unstarted
// // 0 – ended
// // 1 – playing
// // 2 – paused
// // 3 – buffering
// // 5 – video cued

// playerRef.current.getCurrentTime()

// playerRef.current.getDuration()

// playerRef.current.getVideoUrl()

// playerRef.current.getVideoEmbedCode()

// playerRef.current.getPlaylist()

// playerRef.current.getPlaylistIndex()

// playerRef.current.addEventListener(event:String, listener:String)

// playerRef.current.removeEventListener(event:String, listener:String)

// playerRef.current.getIframe()

// playerRef.current.destroy()
